/**
 *  Common
 *
 *  Created by Legman on 4/09/2015.
 *
 */

export default class Common {
    /**
     * @returns {number}
     */
    static getHighscore() {
        const score = window.localStorage["cn_wackyraces"];
        return score || 0;
    }

    /**
     * @param {!number} score
     */
    static saveHighscore(score) {
        if (score > Common.getHighscore()) {
            window.localStorage["cn_wackyraces"] = score;
        }
    }
}

/**
 * @static
 * @type {number}
 * @const
 */
Common.STAGE_WIDTH = 1900;

/**
 * @static
 * @type {number}
 * @const
 */
Common.STAGE_HEIGHT = 768;

/**
 * @static
 * @type {number}
 * @const
 */
Common.PHYSICS_TICK = 1.0 / 30.0;

/**
 * @static
 * @type {number}
 * @const
 */
Common.RACE_ENTITY_SCALE = 764;
//Common.RACE_ENTITY_SCALE = 900;

/**
 * @static
 * @type {PIXI.Container}
 */
Common.stage = null;

/**
 * @static
 * @type {PIXI.CanvasRenderer|PIXI.WebGLRenderer}
 */
Common.renderer = null;

/**
 * @static
 * @type {p3.Timestep}
 */
Common.timestep = null;

/**
 * @static
 * @type {p3.Tracking}
 */
Common.tracking = null;

/**
 * @static
 * @type {AudioManager}
 */
Common.audio = null;

/**
 * @static
 * @type {p3.Camera}
 */
Common.camera = null;

/**
 * @static
 * @type {object}
 */
Common.copy = null;

/**
 * @static
 * @type {object}
 */
Common.config = null;

/**
 * @static
 * @type {string}
 */
Common.language = "en";

/**
 * @static
 * @type {PIXI.Point}
 */
Common.touch = new PIXI.Point(0, 0);

/**
 * @static
 * @type {boolean}
 */
Common.touching = false;

/**
 * @static
 * @type {boolean}
 */
Common.paused = false;

/**
 * @static
 * @type {boolean}
 */
Common.isWebGL = false;

/**
 * @static
 * @type {boolean}
 */
Common.isFirstTime = true;

/**
 * @static
 * @type {PIXI.Texture}
 */
Common.blankTexture = PIXI.Texture.EMPTY;

/**
 * @static
 * @type {number}
 */
Common.playerDriverId = 0;

/**
 * @static
 * @type {string}
 */
Common.previousTrackName = null;
